module.exports = __webpack_public_path__ + "img/xdn.3311a255.svg";